// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ixuGz","load":"Loader_load__9dlYq","loader-component":"Loader_loader-component__2mFvS"};